import { isEqual } from "lodash";
import { usePrevious } from "../hooks";
import { useDeepCompareEffectNoCheck } from "use-deep-compare-effect";
let statuses = {
  inactive: "inactive",
  active: "active",
  loading: "loading",
};

const noop = () => {};

function Googlefontloader({
  onStatus = noop,
  config,
  props,
  children,
  context,
}) {
  const prevConfig = usePrevious({ config });
  useDeepCompareEffectNoCheck(() => {
    if (!isEqual(prevConfig?.config, config)) {
      config.google.families = config.google.families.filter((item) => item);
      if (config?.google?.families?.length > 0) {
        // Import WebFont dynamically
        import(
          /* webpackChunkName: "webfontloader" */
          /* webpackMode: "lazy" */
          "webfontloader"
        )
          .then((WebFont) => {
            WebFont.load({
              ...config,
              loading: () => onStatus(statuses.loading),
              active: () => onStatus(statuses.active),
              inactive: () => onStatus(statuses.inactive),
              context: context
                ? context
                : window?.frames["iframe-renderer"]?.contentWindow,
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }
  }, [config]);

  return children || null;
}

export default Googlefontloader;
